import { Button } from './Button'
import { Dialog } from './Dialog'

export interface ConfirmDialogProps {
  readonly open: boolean
  readonly title: string
  readonly description?: string
  readonly confirmLabel: string
  readonly cancelLabel: string
  readonly variant?: 'danger' | 'primary'
  readonly loading?: boolean
  readonly onConfirm: () => void
  readonly onCancel: () => void
}

/** Confirmação de uma ação (destrutiva por padrão via `variant="danger"`) sobre o Dialog acessível. */
export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel,
  cancelLabel,
  variant = 'danger',
  loading = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      title={title}
      {...(description !== undefined ? { description } : {})}
      footer={
        <>
          <Button variant="ghost" disabled={loading} onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button variant={variant} loading={loading} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </>
      }
    />
  )
}
